<template>
    <div class="phone-box">
        <div class="head-box">
            <div class="head-image-box">
                <img v-if="userData.photoUrl" :src="userData.photoUrl" alt="" class="head-image">
                <img v-else src="@/assets/nopeople.png" alt="" class="head-image">
            </div>
            <div class="head-name">{{userData.name}}</div>
        </div>
        <div class="message">
            <div class="message-item" @click="goList">
                <div class="message-title">宠物列表</div>
                <img src="@/assets/right.png" class="message-right"/>
            </div>
        </div>
        <!-- <div class="btn-box">
            <div class="btn">返回</div>
        </div> -->
    </div>
</template>
<script>
export default {
    data(){
        return{
            userData:JSON.parse(sessionStorage.getItem("TC_PET_USERDATA")),
            imageUrl:process.env.VUE_APP_BASE_API
        }
    },
    methods:{
        goList(){
            this.$router.push("/petList")
        }
    }
}
</script>
<style scoped lang="less">
    .phone-box{
        width:100%;
        height: 100vh;
        overflow: auto;
        background-color: #f3f3f3;
        .head-box{
            padding:20px 0;
            background: linear-gradient(to right,#56ccf2 0%,#146de5 100%);
            .head-image-box{
                width:100px;
                height: 100px;
                margin: auto;
                border:3px solid #69e6ec;
                border-radius: 50%;
                overflow: hidden;
            }
            .head-image{
                width:100%;
            }
            .head-name{
                margin-top:15px;
                font-size: 18px;
                color:#fff;
                text-align: center;
            }
        }
        .message{
            margin-top:15px;
            .message-item{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding:8px 15px;
                margin-bottom:1px;
                background-color: #fff;
            }
            .message-title{
                flex:0 0 90px;
                color:#777;
                font-size: 14px;
            }
            .message-right{
                width:15px;
                height:15px;
                margin-left:15px;
            }
        }
        .btn-box{
            padding:0 20px;
            margin:20px 0;
            .btn{
                padding:8px 25px;
                color:#317aed;
                font-size: 14px;
                border:1px solid #317aed;
                background-color: #fff;
                text-align: center;
                border-radius: 3px;
            }
        }
    }
</style>